import auth from "../middleware/auth";

export default [{
    path: "/goskomles/dashboard_tree",
    name: "dashboard_tree",
    component: () =>
      import ("./../views/goskomles/DashboardTree.vue"),
    meta: {
      middleware: [auth],
      breadcrumb: [{
          title: "Home",
          url: "/"
        },
        {
          i18n: "navmenu.goskomles.forest_statistics",
          title: "Статистика лесов ",
          active: true
        }
      ]
    },
    pageTitle: "Front",
    rule: "editor"
  },
  {
    path: "/goskomles/dashboard_wild",
    name: "dashboard_wild",
    component: () =>
      import ("./../views/goskomles/DashboardWild.vue"),
    meta: {
      middleware: [auth],
      breadcrumb: [{
          title: "Home",
          url: "/"
        },
        {
          title: "Статистика животных ",
          i18n: "navmenu.goskomles.animal_statistics",
          active: true
        }
      ]
    },
    pageTitle: "Front",
    rule: "editor"
  },
  {
    path: "/goskomles/map_tree",
    name: "map_tree",
    component: () =>
      import ("./../views/goskomles/MapTree.vue"),
    meta: {
      middleware: [auth],
      breadcrumb: [{
          title: "Home",
          url: "/"
        },
        {
          title: "Карта лесов ",
          i18n: "navmenu.goskomles.forest_map",
          active: true
        }
      ]
    },
    pageTitle: "Front",
    rule: "editor"
  },
  {
    path: "/goskomles/map_wild",
    name: "map_wild",
    component: () =>
      import ("./../views/goskomles/MapWild.vue"),
    meta: {
      middleware: [auth],
      breadcrumb: [{
          title: "Home",
          url: "/"
        },
        {
          title: "Карта животных ",
          i18n: "navmenu.goskomles.animal_map",
          active: true
        }
      ]
    },
    pageTitle: "Front",
    rule: "editor"
  },

  {
    path: "/goskomles/list_Object",
    name: "list_Object",
    component: () =>
      import ("./../views/goskomles/ListObject.vue"),
    meta: {
      middleware: [auth],
      breadcrumb: [{
          title: "Home",
          url: "/"
        },
        {
          title: "Список объектов ",
          active: true
        }
      ]
    },

    pageTitle: "Front",
    rule: "editor"
  },

  {
    path: "/goskomles/info_object/:id",
    name: "info_Object",
    component: () =>
      import ("./../views/goskomles/InfoObject.vue"),
    meta: {
      middleware: [auth],
      breadcrumb: [{
          title: "Home",
          url: "/"
        },
        {
          title: "Информация объекта",
          active: true
        }
      ]
    },

    pageTitle: "Front",
    rule: "editor"
  }
];